import { Donation } from '../types'

export function parseCSV(text: string): Donation[] {
  const lines = text.split(/\r\n|\n/)
  const headers = parseCSVLine(lines[0])
  const result: Donation[] = []

  // Define the mapping from new CSV headers to old Donation properties
  const columnMapping: Record<string, keyof Donation> = {
    'Total': 'Amount',
    'Billing Name': 'Name',
    'Email': 'Email', // Direct match
    'Billing Country': 'Country',
    'Created at': 'Created at', // Direct match
    // Add other optional mappings if needed, e.g., for address fields
    'Billing Address1': 'Address1',
    'Billing Address2': 'Address2',
    'Billing City': 'City',
    'Billing Zip': 'Zip',
    'Billing Province': 'State/Province'
  }

  // Find the indices of the relevant columns in the new CSV
  const headerIndices: Partial<Record<keyof Donation, number>> = {}
  const newCsvHeaders = Object.keys(columnMapping)

  headers.forEach((header, index) => {
    if (newCsvHeaders.includes(header)) {
      const donationKey = columnMapping[header]
      headerIndices[donationKey] = index
    }
  })

  for (let i = 1; i < lines.length; i++) {
    if (lines[i].trim() === '') continue
    const values = parseCSVLine(lines[i])
    // if (values.length !== headers.length) continue; // This check might be too strict if columns are added/removed

    const donation: Partial<Donation> = {}

    // Populate donation object using the mapped indices
    if (headerIndices['Amount'] !== undefined && values[headerIndices['Amount']]) {
      donation.Amount = values[headerIndices['Amount']]
    }
    if (headerIndices['Name'] !== undefined && values[headerIndices['Name']]) {
      donation.Name = values[headerIndices['Name']]
    }
    if (headerIndices['Email'] !== undefined && values[headerIndices['Email']]) {
      donation.Email = values[headerIndices['Email']]
    }
    if (headerIndices['Created at'] !== undefined && values[headerIndices['Created at']]) {
      donation['Created at'] = values[headerIndices['Created at']]
    }
    if (headerIndices['Country'] !== undefined && values[headerIndices['Country']]) {
      donation.Country = values[headerIndices['Country']]
    }
    if (headerIndices['Address1'] !== undefined && values[headerIndices['Address1']]) {
      donation.Address1 = values[headerIndices['Address1']]
    }
    if (headerIndices['Address2'] !== undefined && values[headerIndices['Address2']]) {
      donation.Address2 = values[headerIndices['Address2']]
    }
    if (headerIndices['City'] !== undefined && values[headerIndices['City']]) {
      donation.City = values[headerIndices['City']]
    }
    if (headerIndices['Zip'] !== undefined && values[headerIndices['Zip']]) {
      donation.Zip = values[headerIndices['Zip']]
    }
    if (headerIndices['State/Province'] !== undefined && values[headerIndices['State/Province']]) {
      donation['State/Province'] = values[headerIndices['State/Province']]
    }

    // Ensure essential fields are present
    if (donation.Amount && donation.Email && donation.Name && donation['Created at']) {
      result.push(donation as Donation)
    }
  }

  return result
}

function parseCSVLine(line: string): string[] {
  const result: string[] = []
  let startValueIndex = 0
  let inQuotes = false

  for (let i = 0; i < line.length; i++) {
    if (line[i] === '"') {
      inQuotes = !inQuotes
    } else if (line[i] === ',' && !inQuotes) {
      result.push(line.substring(startValueIndex, i).trim().replace(/^"(.*)"$/, '$1'))
      startValueIndex = i + 1
    }
  }

  result.push(line.substring(startValueIndex).trim().replace(/^"(.*)"$/, '$1'))
  return result
}

